const peiTeacherType = {
  TiempoCompleto: 3,
  Itinerante: 4,  
};

export default peiTeacherType;
